import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button, Box} from 'views/components';
import {Translate} from 'views/module';
import {Check, Close} from 'views/icons';

import YourCareBoxEdit from './box/YourCareBoxEdit';
import MedicalHistoryBoxEdit from './box/MedicalHistoryBoxEdit';
import CareRoutineBoxEdit from './box/CareRoutineBoxEdit';
import CaregiverBoxEdit from './box/CaregiverBoxEdit';
import CareScheduleBoxEdit from './box/CareScheduleBoxEdit';
import FamilyContactsBoxEdit from './box/FamilyContactsBoxEdit';

import _ from 'lodash';

const FormEdit = (props) => {
  const {data, manuallyUpdateField, setEditMode} = props;

  const [formData, setFormData] = React.useState(data);

  const updateFormData = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    const differences = _.reduce(formData, (result, value, key) => {
      if (!_.isEqual(data[key], value)) {
        result[key] = value;
      }
      return result;
    }, {});

    await manuallyUpdateField({values: differences});

    setEditMode(false);
  };

  const handleCancel = () => {
    setFormData(data);
    setEditMode(false);
  };

  return (
    <Box sx={{position: 'relative', height: '100%', minHeight: 400}}>
      <Stack spacing={2}>
        <YourCareBoxEdit
          data={formData}
          updateFormData={updateFormData}
        />
        <MedicalHistoryBoxEdit
          data={formData}
          updateFormData={updateFormData}
        />
        <CareRoutineBoxEdit
          data={formData}
          updateFormData={updateFormData}
        />
        <CaregiverBoxEdit
          data={formData}
          updateFormData={updateFormData}
        />
        <CareScheduleBoxEdit
          data={formData}
          updateFormData={updateFormData}
        />
        <FamilyContactsBoxEdit
          data={formData}
          updateFormData={updateFormData}
        />
      </Stack>

      { /* Save/Cancel Buttons */}
      <Box
        sx={{
          position: 'sticky',
          bottom: 16,
          zIndex: 1000,
          display: 'flex',
          gap: '0.5rem',
          marginLeft: 'auto',
          width: 'fit-content',
        }}
      >
        <Button
          onClick={handleSave}
          style={{
            background: '#3060d9',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontWeight: 600,
            borderRadius: 8,
          }}
        >
          <Check style={{color: '#fff', fontSize: 16}} />
          <Translate expression="profile.EditMode.Save" />
        </Button>
        <Button
          variant="outlined"
          onClick={handleCancel}
          style={{
            borderColor: '#d1d5db',
            color: '#374151',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontWeight: 500,
            borderRadius: 8,
            background: '#fff',
          }}
        >
          <Close style={{color: '#374151', fontSize: 16}} />
          <Translate expression="profile.EditMode.Cancel" />
        </Button>
      </Box>
    </Box>
  );
};

FormEdit.propTypes = {
  data: PropTypes.object.isRequired,
  manuallyUpdateField: PropTypes.func.isRequired,
  setEditMode: PropTypes.func.isRequired,
};

export default FormEdit;
